import Grid from "@mui/material/Grid2";

import MDBox from "@/components/atoms/MDBox";
import { IOrderInput } from "@/interfaces/order.interfaces";
import { PaymentDataTabMessages } from "@/messages/order-form-page/payment-data-tab.messages";

import OrderComments from "./components/OrderComments";
import Payments from "./components/Payments";
import Values from "./components/Values";

type Props = {
  messages: PaymentDataTabMessages;
  order: IOrderInput | null;
};

export default function PaymentDataTab({ messages, order }: Props) {
  return (
    <MDBox mt={2}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, lg: 8 }}>
          <MDBox height="100%">
            <Values messages={messages} />
          </MDBox>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <MDBox height="100%">
            <OrderComments messages={messages} />
          </MDBox>
        </Grid>

        <Grid size={{ xs: 12, lg: 12 }}>
          <Payments messages={messages} order={order} />
        </Grid>
      </Grid>
    </MDBox>
  );
}
